import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";

export const getDatasheetFolders = async (): Promise<Array<Partial<FolderPrimaryListDto>>> => {
  return Promise.resolve([
    {
      id: 3,
      name: "Progeny",
      parentid: 0,
    },
    {
      id: 4,
      name: "Progeny",
      parentid: 3,
    },
    {
      id: 10,
      name: "CORE - Questionnaire Formats",
      parentid: 4,
    },
    {
      id: 11,
      name: "CORE - IDS Formats",
      parentid: 10,
    },
    {
      id: 12,
      name: "CORE - Progeny",
      parentid: 0,
    },
    {
      id: 13,
      name: "QA",
      parentid: 0,
    },
    {
      id: 14,
      name: "Test",
      parentid: 0,
    },
    {
      id: 99,
      name: "CORE - Progeny 2",
      parentid: 0,
    },
    {
      id: 789,
      name: "QA 2",
      parentid: 0,
    },
    {
      id: 91199,
      name: "Test 2",
      parentid: 0,
    },
    {
      id: 99,
      name: "CORE - Progeny 2",
      parentid: 0,
    },
    {
      id: 19999,
      name: "QA 2",
      parentid: 0,
    },
    {
      id: 99299,
      name: "Test 3",
      parentid: 0,
    },
  ]);
};
